
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			reminderTime: 10,
			reminderTimeSpan: "minutes"
		};
	},
	props: {
		reminder: {
			type: Object as () => { method: gapi.client.calendar.ReminderMethod, minutes: gapi.client.calendar.integer }
		}
	},
	computed: {

		notificationTypes(): ISelectItem<string>[] {
			return [
				"email",
				"popup",
			].map(l => {
				return {
					text: this.$ct("type." + l),
					value: l
				} as ISelectItem<string>;
			});
		},
		notificationTimeSpan(): ISelectItem<string>[] {
			return Object.keys(this.$ct("time")).map(l => {
				return {
					text: this.$ct("time." + l),
					value: l
				} as ISelectItem<string>;
			});
		},
	},
	watch: {},
	methods: {
		updateReminderMinutes() {

			if (!this.reminderTimeSpan)
				return;

			if (this.reminderTimeSpan == "minutes") {
				this.reminder.minutes = this.reminderTime;
			}

			if (this.reminderTimeSpan == "hours") {
				this.reminder.minutes = this.reminderTime * 60;
			}

			if (this.reminderTimeSpan == "days") {
				this.reminder.minutes = this.reminderTime * 1440;
			}

			if (this.reminderTimeSpan == "weeks") {
				this.reminder.minutes = this.reminderTime * 10080;
			}



		},
		formatReminderTimeSpan() {

			if (this.reminder.minutes < 60) {
				this.reminderTimeSpan = "minutes";
				this.reminderTime = this.reminder.minutes;
			}
			if (Math.floor(this.reminder.minutes / 60) >= 1) {
				this.reminderTimeSpan = "hours";
				this.reminderTime = Math.ceil(this.reminder.minutes / 60);
			}
			if (Math.floor(this.reminder.minutes / 60) >= 24) {
				this.reminderTimeSpan = "days";
				this.reminderTime = Math.ceil(this.reminder.minutes / 1440);
			}
			if (Math.floor(this.reminder.minutes / 60) >= 168) {
				this.reminderTimeSpan = "weeks";
				this.reminderTime = Math.ceil(this.reminder.minutes / 10080);
			}
		},
		remove() {
			this.$emit("remove");
		}
	},
	async mounted() {
		this.formatReminderTimeSpan();
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
